import { render, staticRenderFns } from "./VipProduct.vue?vue&type=template&id=33da54b3&"
import script from "./VipProduct.vue?vue&type=script&lang=js&"
export * from "./VipProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports